import React from 'react'
import ReactDOM from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.css'
// Enable Bootstrap's interactive components (Dropdowns, Modals, etc.)
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './index.css'
import './styles/common.css'
import './styles/badges.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import { initAnalytics } from './analytics'
import AuthProvider from './context/AuthProvider'
import { initConsoleFilters } from './utils/consoleFilters'
import { isMobilePlatform } from './utils/mobileAuth'

// Initialize console filters before any other initialization
// This must happen early to catch GSI script console output
initConsoleFilters()

// Initialize analytics after imports
initAnalytics()

// Conditionally select router based on platform
// Mobile (Capacitor) uses HashRouter for deep link support without server fallback
// Web uses BrowserRouter for standard history API routing
const Router = isMobilePlatform() ? HashRouter : BrowserRouter

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
